// action
import OdataCoreActionBase from "./OdataCoreActionBase";
// enum
import EActionStatus from "@/core/enums/EActionStatus";
import EActionType from "@/core/enums/EActionType";
// interface
import { IActionDetailsOdata } from "@/core/types/TActionDetails";
import TActionRunParams from "@/core/types/TActionRunParams";


class OdataReadOnlyActionBase extends OdataCoreActionBase {

    async details( params: IActionDetailsOdata ) {

        this.fetching(EActionType.DETAILS);

        const serviceParams: TActionRunParams = {
            args: {
                ...params.args, 
                actionType: EActionType.DETAILS
            },
            servicePayload: params.servicePayload
        }

        this.executeService( this.service.details.bind(this.service), serviceParams );

    }

    async detailsStore ( params: IActionDetailsOdata ) {

        this.store(EActionType.DETAILS, params.payload);
        
    }

    detailsClean () {
    
        this.clean(EActionType.DETAILS);
    
    }

}

export default OdataReadOnlyActionBase;
